export default __webpack_public_path__ + "locales/de/ResetApplicationDialog.json?hash=16c63fd546a6f9dbdb6291eea7c3571f";